import toggleAttachmentGroup from './common/toggle-attachment-group'
import updateInputsInOtherGroups from './common/update-inputs-in-other-groups'
import updateAccountMasterGroupInput from '@app/application/export/behaviours/export-form-tools/widgets/account/common/update-account-master-group-input'

function toggleAllMaster() {
  const $this = $(this)
  const $allInputsForGroup = $this
    .closest('.check-master-group')
    .find('[data-behaviour="export-check-group"]')
  $this.prop('disabled', true)
  $allInputsForGroup.each(function () {
    $(this).prop('checked', $this.prop('checked')).trigger('updated')
    $(this).trigger('change')
  })
  $this.prop('disabled', false)
}

function toggleAll() {
  const $this = $(this)
  $this.closest('tr').find('.export-attachment input').prop('checked', false)
  const $allInputsForGroup = $this
    .closest('table')
    .find('tr.level_1 .export-account-check input')
  $allInputsForGroup.each(function () {
    $(this).prop('checked', $this.prop('checked')).trigger('updated')
    updateInputsInOtherGroups($(this))
  })

  toggleAttachmentGroup($this.closest('table'))
  updateAccountMasterGroupInput($this.closest('.check-master-group'))
}

export default () => {
  $(document).on('change', '[data-behaviour="export-check-group"]', toggleAll)
  $(document).on(
    'change',
    '[data-behaviour="export-check-group-master"]',
    toggleAllMaster
  )

  return () => {
    $(document).off(
      'change',
      '[data-behaviour="export-check-group"]',
      toggleAll
    )

    $(document).off(
      'change',
      '[data-behaviour="export-check-group-master"]',
      toggleAllMaster
    )
  }
}
